import { wgs84ToBd09 } from '@/util/coordTransform'

export type MapType = 'google' | 'baidu'

/**
 * 통합 역지오코딩 함수
 * Google Maps 또는 Baidu Maps의 Geocoder를 사용하여 좌표 -> 주소 변환
 */
export function reverseGeocode(
    mapType: MapType,
    lat: number,
    lng: number
): Promise<string> {
    if (mapType === 'baidu') {
        return baiduReverseGeocode(lat, lng)
    }
    return googleReverseGeocode(lat, lng)
}

function googleReverseGeocode(lat: number, lng: number): Promise<string> {
    return new Promise((resolve) => {
        if (!google?.maps?.Geocoder) {
            resolve('Geocoder not available')
            return
        }
        const geocoder = new google.maps.Geocoder()
        geocoder.geocode(
            { location: { lat, lng } },
            (results, status) => {
                if (status === 'OK' && results && results[0]) {
                    resolve(results[0].formatted_address)
                } else {
                    resolve('Geocoding failed')
                }
            }
        )
    })
}

function baiduReverseGeocode(lat: number, lng: number): Promise<string> {
    return new Promise((resolve) => {
        if (!window.BMapGL) {
            resolve('Baidu Maps not loaded')
            return
        }
        const [bdLat, bdLng] = wgs84ToBd09(lat, lng)
        const geocoder = new window.BMapGL.Geocoder()
        const point = new window.BMapGL.Point(bdLng, bdLat)
        geocoder.getLocation(point, (result: any) => {
            if (result?.address) {
                resolve(result.address)
            } else {
                resolve('Geocoding failed')
            }
        })
    })
}
